const common =
{
  height: '64px'
}

export const web =
{
  ...common,

  height: '36px'
}

export const tablet =
{
  ...common
}
